import { normalizeColor } from './utils/colorUtils';
/** Browser values from the exact element at scan time. Kept separately
 * from computedCss, which legacy AI responses can populate with estimates. */
export const STYLE_CAPTURE_PROPERTIES = [
    'fontFamily', 'fontSize', 'fontWeight', 'lineHeight', 'letterSpacing', 'padding', 'margin',
    'width', 'height', 'boxSizing', 'color', 'backgroundColor',
    'borderTop', 'borderRight', 'borderBottom', 'borderLeft', 'borderRadius', 'boxShadow',
    'display', 'gap', 'rowGap', 'columnGap',
];
/** A CSS custom property name, as getComputedStyle enumerates it. */
const TOKEN_NAME = /^--[\p{L}\p{N}_-]{1,200}$/u;
export function readStyleCapture(value) {
    if (!value || typeof value !== 'object')
        return;
    const v = value;
    if (typeof v.capturedAt !== 'string' || !Number.isFinite(Date.parse(v.capturedAt))
        || typeof v.nodeId !== 'string' || !v.nodeId || !v.values || typeof v.values !== 'object')
        return;
    const values = {};
    for (const key of STYLE_CAPTURE_PROPERTIES) {
        const entry = v.values[key];
        if (typeof entry === 'string' && entry.trim() && entry.length <= 500)
            values[key] = entry;
    }
    if (!Object.keys(values).length)
        return undefined;
    // A token labels a captured value, so one with no value beside it is dropped.
    const tokens = {};
    const offered = v.tokens && typeof v.tokens === 'object' ? v.tokens : {};
    for (const key of STYLE_CAPTURE_PROPERTIES) {
        const name = offered[key];
        if (values[key] && typeof name === 'string' && TOKEN_NAME.test(name))
            tokens[key] = name;
    }
    return { capturedAt: v.capturedAt, nodeId: v.nodeId, values, ...(Object.keys(tokens).length ? { tokens } : {}) };
}
/** A captured value as people read it: each opaque rgb() color as hex ("1px solid #dcdcdc"), then the token it
 * matches in parentheses ("#0f766e (--brand)"). Translucent colors and other text stay as captured. */
export function styleValueText(value, token) {
    const text = value.replace(/rgba?\([^)]*\)/gi, color => normalizeColor(color) ?? color);
    return token ? `${text} (${token})` : text;
}
//# sourceMappingURL=styleCapture.js.map